(() => {
  const observers = new WeakMap();

  function setup(root) {
    const sections = [
      ...(root.matches?.('product-recommendations') ? [root] : []),
      ...root.querySelectorAll('product-recommendations')
    ];
    sections.forEach((section) => {
      if (section.dataset.miCarouselReady === 'true') return;
      const carousel = section.querySelector('slideshow-component.resource-list__carousel');
      if (!carousel || !carousel.slides || carousel.slides.length < 2) return;

      section.dataset.miCarouselReady = 'true';
      section.dataset.miCarouselMode = 'manual';
      observers.get(section)?.disconnect();
      observers.delete(section);
    });
  }

  function watch(root = document) {
    const sections = [
      ...(root.matches?.('product-recommendations') ? [root] : []),
      ...root.querySelectorAll('product-recommendations')
    ];
    sections.forEach((section) => {
      setup(section);
      if (section.dataset.miCarouselReady === 'true' || observers.has(section)) return;
      const observer = new MutationObserver(() => setup(section));
      observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recommendations-performed'] });
      observers.set(section, observer);
    });
  }

  const init = (root = document) => watch(root);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
